<div class="content">
  <div class="configurationBannerHeader">
    <span class="configurationBannerLabel">Fan Curves</span>
  </div>
  <div class="detail">
    <div class="configurationDetailRow">
      <canvas #lineChart></canvas>
    </div>
  </div>
</div>
